import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from 'app/app.module';

// Bootstrap — eslint-disable-next-line
platformBrowserDynamic().bootstrapModule(AppModule)
                        .catch(err => console.error(err));
